module.exports = __webpack_public_path__ + "static/media/color.844494a0.svg";